module.exports = __webpack_public_path__ + "img/1.9cfd0c8f.png";